// Mock data for EMIDash — backend integration point
// BACKEND: Replace all mock data with API calls to your database

import { calculateEMI, generateAmortization, getEMIStatus } from './formatters';

export interface Loan {
  id: string;
  name: string;
  lender: string;
  type: 'Home' | 'Car' | 'Personal' | 'Credit Card' | 'Phone' | 'Other';
  principal: number;
  annualRate: number;
  tenureMonths: number;
  startDate: string; // ISO date string
  notes?: string;
  payments: Payment[];
}

export interface Payment {
  id: string;
  loanId: string;
  monthIndex: number; // 1-based month number in the amortization schedule
  monthLabel: string;
  paidOn: string; // ISO date string
  amount: number;
}

export interface User {
  id: string;
  name: string;
  email: string;
  monthlyIncome?: number;
  memberSince: string;
}

// Mock current user
// BACKEND: Replace with session/auth provider user object
export const MOCK_USER: User = {
  id: 'user-001',
  name: 'Arjun Mehta',
  email: 'arjun.mehta@gmail.com',
  monthlyIncome: 95000,
  memberSince: '2024-08-12',
};

// Mock loans
// BACKEND: Replace with GET /api/loans
export const MOCK_LOANS: Loan[] = [
  {
    id: 'loan-001',
    name: 'SBI Home Loan',
    lender: 'State Bank of India',
    type: 'Home',
    principal: 4500000,
    annualRate: 8.65,
    tenureMonths: 240,
    startDate: '2022-03-01',
    notes: 'Floating rate — review in March 2026',
    payments: [
      { id: 'pay-001-01', loanId: 'loan-001', monthIndex: 1, monthLabel: 'Mar 2022', paidOn: '2022-03-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-02', loanId: 'loan-001', monthIndex: 2, monthLabel: 'Apr 2022', paidOn: '2022-04-04', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-03', loanId: 'loan-001', monthIndex: 3, monthLabel: 'May 2022', paidOn: '2022-05-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-04', loanId: 'loan-001', monthIndex: 4, monthLabel: 'Jun 2022', paidOn: '2022-06-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-05', loanId: 'loan-001', monthIndex: 5, monthLabel: 'Jul 2022', paidOn: '2022-07-04', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-06', loanId: 'loan-001', monthIndex: 6, monthLabel: 'Aug 2022', paidOn: '2022-08-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-07', loanId: 'loan-001', monthIndex: 7, monthLabel: 'Sep 2022', paidOn: '2022-09-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-08', loanId: 'loan-001', monthIndex: 8, monthLabel: 'Oct 2022', paidOn: '2022-10-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-09', loanId: 'loan-001', monthIndex: 9, monthLabel: 'Nov 2022', paidOn: '2022-11-04', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-10', loanId: 'loan-001', monthIndex: 10, monthLabel: 'Dec 2022', paidOn: '2022-12-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-11', loanId: 'loan-001', monthIndex: 11, monthLabel: 'Jan 2023', paidOn: '2023-01-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-12', loanId: 'loan-001', monthIndex: 12, monthLabel: 'Feb 2023', paidOn: '2023-02-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-13', loanId: 'loan-001', monthIndex: 13, monthLabel: 'Mar 2023', paidOn: '2023-03-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-14', loanId: 'loan-001', monthIndex: 14, monthLabel: 'Apr 2023', paidOn: '2023-04-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-15', loanId: 'loan-001', monthIndex: 15, monthLabel: 'May 2023', paidOn: '2023-05-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-16', loanId: 'loan-001', monthIndex: 16, monthLabel: 'Jun 2023', paidOn: '2023-06-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-17', loanId: 'loan-001', monthIndex: 17, monthLabel: 'Jul 2023', paidOn: '2023-07-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-18', loanId: 'loan-001', monthIndex: 18, monthLabel: 'Aug 2023', paidOn: '2023-08-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-19', loanId: 'loan-001', monthIndex: 19, monthLabel: 'Sep 2023', paidOn: '2023-09-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-20', loanId: 'loan-001', monthIndex: 20, monthLabel: 'Oct 2023', paidOn: '2023-10-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-21', loanId: 'loan-001', monthIndex: 21, monthLabel: 'Nov 2023', paidOn: '2023-11-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-22', loanId: 'loan-001', monthIndex: 22, monthLabel: 'Dec 2023', paidOn: '2023-12-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-23', loanId: 'loan-001', monthIndex: 23, monthLabel: 'Jan 2024', paidOn: '2024-01-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-24', loanId: 'loan-001', monthIndex: 24, monthLabel: 'Feb 2024', paidOn: '2024-02-05', amount: calculateEMI(4500000, 8.65, 240) },
      { id: 'pay-001-25', loanId: 'loan-001', monthIndex: 25, monthLabel: 'Mar 2024', paidOn: '2024-03-05', amount: calculateEMI(4500000, 8.65, 240) },
    ],
  },
  {
    id: 'loan-002',
    name: 'HDFC Car Loan',
    lender: 'HDFC Bank',
    type: 'Car',
    principal: 750000,
    annualRate: 9.25,
    tenureMonths: 60,
    startDate: '2023-07-01',
    payments: [
      { id: 'pay-002-01', loanId: 'loan-002', monthIndex: 1, monthLabel: 'Jul 2023', paidOn: '2023-07-07', amount: calculateEMI(750000, 9.25, 60) },
      { id: 'pay-002-02', loanId: 'loan-002', monthIndex: 2, monthLabel: 'Aug 2023', paidOn: '2023-08-07', amount: calculateEMI(750000, 9.25, 60) },
      { id: 'pay-002-03', loanId: 'loan-002', monthIndex: 3, monthLabel: 'Sep 2023', paidOn: '2023-09-07', amount: calculateEMI(750000, 9.25, 60) },
      { id: 'pay-002-04', loanId: 'loan-002', monthIndex: 4, monthLabel: 'Oct 2023', paidOn: '2023-10-07', amount: calculateEMI(750000, 9.25, 60) },
      { id: 'pay-002-05', loanId: 'loan-002', monthIndex: 5, monthLabel: 'Nov 2023', paidOn: '2023-11-07', amount: calculateEMI(750000, 9.25, 60) },
      { id: 'pay-002-06', loanId: 'loan-002', monthIndex: 6, monthLabel: 'Dec 2023', paidOn: '2023-12-07', amount: calculateEMI(750000, 9.25, 60) },
      { id: 'pay-002-07', loanId: 'loan-002', monthIndex: 7, monthLabel: 'Jan 2024', paidOn: '2024-01-07', amount: calculateEMI(750000, 9.25, 60) },
      { id: 'pay-002-08', loanId: 'loan-002', monthIndex: 8, monthLabel: 'Feb 2024', paidOn: '2024-02-07', amount: calculateEMI(750000, 9.25, 60) },
      { id: 'pay-002-09', loanId: 'loan-002', monthIndex: 9, monthLabel: 'Mar 2024', paidOn: '2024-03-07', amount: calculateEMI(750000, 9.25, 60) },
    ],
  },
  {
    id: 'loan-003',
    name: 'Bajaj Personal Loan',
    lender: 'Bajaj Finserv',
    type: 'Personal',
    principal: 300000,
    annualRate: 13.5,
    tenureMonths: 36,
    startDate: '2024-01-15',
    payments: [
      { id: 'pay-003-01', loanId: 'loan-003', monthIndex: 1, monthLabel: 'Jan 2024', paidOn: '2024-01-20', amount: calculateEMI(300000, 13.5, 36) },
      { id: 'pay-003-02', loanId: 'loan-003', monthIndex: 2, monthLabel: 'Feb 2024', paidOn: '2024-02-20', amount: calculateEMI(300000, 13.5, 36) },
      { id: 'pay-003-03', loanId: 'loan-003', monthIndex: 3, monthLabel: 'Mar 2024', paidOn: '2024-03-20', amount: calculateEMI(300000, 13.5, 36) },
    ],
  },
  {
    id: 'loan-004',
    name: 'Apple iPhone EMI',
    lender: 'Axis Bank',
    type: 'Phone',
    principal: 89900,
    annualRate: 14.0,
    tenureMonths: 12,
    startDate: '2024-02-10',
    payments: [
      { id: 'pay-004-01', loanId: 'loan-004', monthIndex: 1, monthLabel: 'Feb 2024', paidOn: '2024-02-15', amount: calculateEMI(89900, 14.0, 12) },
      { id: 'pay-004-02', loanId: 'loan-004', monthIndex: 2, monthLabel: 'Mar 2024', paidOn: '2024-03-15', amount: calculateEMI(89900, 14.0, 12) },
    ],
  },
];

/**
 * Calculate derived loan metrics for display
 */
export function getLoanMetrics(loan: Loan) {
  const emi = calculateEMI(loan.principal, loan.annualRate, loan.tenureMonths);
  const amort = generateAmortization(loan.principal, loan.annualRate, loan.tenureMonths, new Date(loan.startDate));
  const paidCount = loan.payments.length;
  const remainingMonths = loan.tenureMonths - paidCount;
  const percentComplete = Math.round((paidCount / loan.tenureMonths) * 100);

  // Outstanding balance = closing balance after last paid month
  let outstandingBalance = loan.principal;
  if (paidCount > 0 && amort[paidCount - 1]) {
    outstandingBalance = amort[paidCount - 1].closingBalance;
  }

  // Total interest paid so far
  const totalInterestPaid = loan.payments.reduce((sum, p, idx) => {
    const row = amort[idx];
    return sum + (row ? row.interest : 0);
  }, 0);

  // Total principal paid so far
  const totalPrincipalPaid = loan.principal - outstandingBalance;

  // Next due date — first unpaid month
  const nextDueIndex = paidCount; // 0-based
  const startD = new Date(loan.startDate);
  const nextDue = new Date(startD);
  nextDue.setMonth(nextDue.getMonth() + nextDueIndex);

  // End date
  const endDate = new Date(startD);
  endDate.setMonth(endDate.getMonth() + loan.tenureMonths - 1);

  // Total interest payable (full loan)
  const totalInterestPayable = emi * loan.tenureMonths - loan.principal;

  return {
    emi,
    paidCount,
    remainingMonths,
    percentComplete,
    outstandingBalance,
    totalInterestPaid,
    totalPrincipalPaid,
    nextDue,
    endDate,
    totalInterestPayable,
    amort,
    status: getEMIStatus(nextDue.toISOString(), false),
  };
}